import { IBookMark } from '#/types/bookmark';

export const BookMarksActionType = {
  BOOKMARKS_ADD_BOOKMARK: 'bookmarks/add_bookmark',
  BOOKMARKS_REMOVE_BOOKMARK: 'bookmarks/remove_bookmark',
  BOOKMARKS_REMOVE_ALL_BOOKMARKS: 'bookmarks/remove_all_bookmarks',
  BOOKMARKS_START_LOADING: 'bookmarks/start_loading',
  BOOKMARKS_STOP_LOADING: 'bookmarks/stop_loading',
} as const;

export type TBookMarksActions =
  | {
      type: typeof BookMarksActionType.BOOKMARKS_ADD_BOOKMARK;
      payload: IBookMark;
    }
  | {
      type: typeof BookMarksActionType.BOOKMARKS_REMOVE_BOOKMARK;
      payload: IBookMark;
    }
  | {
      type: typeof BookMarksActionType.BOOKMARKS_REMOVE_ALL_BOOKMARKS;
    }
  | {
      type: typeof BookMarksActionType.BOOKMARKS_START_LOADING;
    }
  | {
      type: typeof BookMarksActionType.BOOKMARKS_STOP_LOADING;
    };
